
import { eventBus } from '@tencent/syzs-login-sdk-utils';
import { useEffect } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import './App.less';
import i18n, { ILanguage } from './i18n';
import { LoginRequest, postMessageToParent } from './lib';
import IPC from './pages/IPC';
import LoginMain from './pages/Login/LoginMain';
import RegisterMain from './pages/Login/RegisterMain';
import { RegisterMainMobile } from './pages/Login/RegisterMainMobile';
import LoginCallBack from './pages/LoginCallBack';
import MailVerificationMain from './pages/MailVerificationMain/MailVerificationMain';
import { ILoginType } from './types';


const App = () => {
  useEffect(() => {
    eventBus.on('clearLoginState', (info: any) => {
      switch (info) {
        case ILoginType.gg: {
          if (!window.gapi?.auth2) return;

          const auth2 = window.gapi.auth2.getAuthInstance();
          void auth2.signOut()
            .then(() => {
              auth2.disconnect();
            });
        }

          break;
        case ILoginType.fb:
          window.FB?.logout();
          break;
        default:
          break;
      }
    });

    eventBus.on('USER_BIND_MAIL_SUCCESS', (email: string) => {
      const userInfoTemp = LoginRequest.getLoginInfolocalStorage();
      if (!userInfoTemp) return;

      userInfoTemp.userinfo.userBindMail = email;
      LoginRequest.setLoginInfolocalStorage(userInfoTemp);

      setTimeout(() => {
        void postMessageToParent('USER_BIND_MAIL_SUCCESS', email);
      }, 2000);
    });
  }, []);

  useEffect(() => {
    if (window.location.hash && window.location.hash === '#_=_') {
      window.location.hash = '';
    }

    const defaultLang = localStorage.getItem('syzs_lang');

    if (defaultLang) {
      void i18n.initI18n(defaultLang as ILanguage);
    }
  }, []);

  return (
    <div className="syzs-login">
      <HashRouter>
        <Routes>
          <Route path="/" element={<LoginCallBack />} />
          <Route path="MailVerificationMain" element={<MailVerificationMain />} />
          <Route path="Login" element={<LoginMain />} />
          <Route path="IPC" element={<IPC />} />
          <Route path="RegisterMain" element={<RegisterMain />} />
          <Route path="RegisterMainMobile" element={<RegisterMainMobile />} />
        </Routes>
      </HashRouter>
    </div>
  );
};


export default App;
